import range from "lodash/range";
export function getVisiblePages(page, totalPages) {
  const numberOfSequentialPages = 5;
  const currentPage = page + 1;
  if (totalPages <= numberOfSequentialPages + 2) {
    return range(1, totalPages + 1);
  }
  if (currentPage < numberOfSequentialPages) {
    return [...range(1, numberOfSequentialPages + 1), totalPages];
  }
  if (currentPage + numberOfSequentialPages - 1 > totalPages) {
    return [1, ...range(totalPages - numberOfSequentialPages + 2, totalPages + 1)];
  }
  return [1, ...range(currentPage - 2, currentPage + numberOfSequentialPages - 2), totalPages];
}